import { type CSSProperties } from 'react'
import { ReportRequestStateEnum } from '__codegen__/api'
import { dashColors } from 'legacy/dash-blocks/foundation/colors'
import { type DashMessages } from 'intl/intl.types'
import { type DashButtonProps } from 'legacy/dash-blocks/dash-button/utils/dashButton.types'

export const STATUS_BUTTON_STYLE: CSSProperties = {
  minWidth: '90px',
  justifyContent: 'center',
}

export const statusButtonLabels: { [key in ReportRequestStateEnum]: DashMessages } = {
  [ReportRequestStateEnum.New]: 'generatedReports.status.NEW',
  [ReportRequestStateEnum.Complete]: 'generatedReports.status.COMPLETE',
  [ReportRequestStateEnum.InProgress]: 'generatedReports.status.IN_PROGRESS',
  [ReportRequestStateEnum.Failed]: 'generatedReports.status.FAILED',
}

export function generateButtonProps(status: ReportRequestStateEnum): Partial<DashButtonProps> {
  switch (status) {
    case ReportRequestStateEnum.Complete:
      return {
        variant: 'outline-standard',
      }
    case ReportRequestStateEnum.New:
      return {
        variant: 'outline-standard',
        buttonStyle: {
          backgroundColor: dashColors.WHITE,
          color: dashColors.DARK_NEUTRAL,
          border: `1px solid ${dashColors.DARK_NEUTRAL}`,
          opacity: 0.8,
        },
      }
    case ReportRequestStateEnum.Failed:
      return {
        variant: 'outline-danger',
        buttonStyle: {
          backgroundColor: dashColors.WHITE,
          color: dashColors.DANGER,
          border: `1px solid ${dashColors.DANGER}`,
          opacity: 0.8,
        },
      }
    default:
      return {
        variant: 'standard',
      }
  }
}
